export const telNumber = '+44 (0)7974 872 772'
export const officeNumber = '+44 (0)1256 479 453'
export const emailAddress = 'clear.h2o@live.co.uk'
export const officeAddress =
  '65 Sinclair Drive, Basingstoke, Hampshire, RG21 6AF'



// WEBPACK FOOTER //
// ./src/utils/variables.js